export default {
      id: "ic_button_lost-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_button_lost-usage",
      toString: function () {
        return this.url;
      }
    }